// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.station-spawner-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.station-spawner-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  position: relative;
  width: clamp(420px, 34vw, 560px);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}
.station-spawner-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .station-spawner-shell {
    animation: none;
  }
}

.station-spawner-header {
  flex: 0 0 auto;
  padding: 20px 56px 14px 24px;
}
.station-spawner-header__brand {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-bottom: 4px;
}
.station-spawner-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
}
.station-spawner-header__tagline {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin-top: 6px;
}

.station-spawner-search {
  flex: 0 0 auto;
  padding: 0 24px 10px;
}
.station-spawner-search input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.station-spawner-search input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.station-spawner-search input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.station-spawner-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  list-style: none;
  margin: 0;
  padding: 4px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.station-spawner-list::-webkit-scrollbar {
  width: 6px;
}
.station-spawner-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.station-spawner-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 8px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.station-spawner-item:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.12);
}
.station-spawner-item:focus-visible {
  color: #ebe8e1;
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.station-spawner-item__name {
  font-size: 14px;
  font-weight: 600;
}
.station-spawner-item__id {
  font-size: 13px;
  color: #8d8a82;
}

.station-spawner-empty {
  padding: 8px 10px;
  font-size: 14px;
  color: #8d8a82;
}

.station-spawner-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.station-spawner-footer__hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.station-spawner-footer__hint kbd {
  display: inline-block;
  padding: 1px 6px;
  margin-right: 6px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  color: #aeaba2;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}
.station-spawner-footer__status {
  font-size: 13px;
  text-align: right;
  color: var(--gold-light);
}

.station-spawner-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  position: absolute;
  top: 14px;
  right: 16px;
  padding: 2px 10px;
  font-size: 20px;
  line-height: 1.2;
}
.station-spawner-close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.station-spawner-close:active:not(:disabled) {
  transform: translateY(1px);
}
.station-spawner-close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.station-spawner-close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.station-spawner-close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/stationSpawner/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AALA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yDDkBU;ACXZ;;AAJA;EDkBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC5JA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAaF;ADAE;EAAI,sBAAA;ACGN;AD0IE;ECjKF;IDiK4C,eAAA;ECtI1C;AACF;;AAlBA;EACE,cAAA;EACA,4BAAA;AAqBF;AAnBE;ED0CA,eAAA;EACA,gBAAA;EACA,cAlDO;ECQL,kBAAA;AAuBJ;AApBE;EDsBA,kDA3BW;EA4BX,gBAAA;EACA,eCvBqB;EDwBrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECeH,SAAA;AA2BJ;AAxBE;ED0BA,eAAA;EACA,gBAAA;EACA,cA7CO;ECmBL,eAAA;AA4BJ;;AAxBA;EACE,cAAA;EACA,oBAAA;AA2BF;AAzBE;EDwFA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;AC5DF;AD8DE;EAAU,aAAA;EAAe,8BAAA;AC1D3B;AD2DE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACpD1G;;AA1CA;ED+GE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC/GA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA+CF;AD2DE;EAAuB,UAAA;ACxDzB;ADyDE;EAA6B,oCAAA;EAAsC,kBAAA;ACrDrE;;AAnDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yDD3CU;EC4CV,gBAAA;EACA,cDrDO;ECsDP,uBAAA;EACA,6BAAA;EACA,kBDpDO;ECqDP,eAAA;EACA,kFAAA;AAsDF;AApDE;EACE,cD9DG;EC+DH,qCDnES;ECoET,uCDlEG;ACwHP;AAnDE;EACE,cDpEG;ECqEH,oCAAA;EACA,oBAAA;AAqDJ;AAlDE;EACE,eAAA;EACA,gBAAA;AAoDJ;AAjDE;EACE,eAAA;EACA,cD9EK;ACiIT;;AA/CA;EACE,iBAAA;EACA,eAAA;EACA,cDrFO;ACuIT;;AA/CA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,+CAAA;AAkDF;AAhDE;EDjDA,eAAA;EACA,gBAAA;EACA,cAlDO;ACsJT;AAlDI;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yDDjGM;ECkGN,eAAA;EACA,cD3GG;EC4GH,0CAAA;EACA,kBAAA;AAoDN;AAhDE;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;AAkDJ;;AA9CA;ED1DE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ECmBA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAkEF;ADnHE;EAAyB,qCAAA;EAAuC,8BAAA;ACuHlE;ADtHE;EAA0B,0BAAA;ACyH5B;ADxHE;EAAa,YAAA;EAAc,mBAAA;AC4H7B;AD3HE;EAAkB,oCAAA;EAAsC,mBAAA;AC+H1D;ADvGE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC4GhF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Crafting station spawner (admin): centred ink modal with a searchable list.\n\n.station-spawner-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  font-family: ink.$font-text;\n}\n\n.station-spawner-shell {\n  @include ink.panel;\n  @include ink.enter;\n  position: relative;\n  width: clamp(420px, 34vw, 560px);\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.station-spawner-header {\n  flex: 0 0 auto;\n  padding: 20px 56px 14px 24px;\n\n  &__brand {\n    @include ink.hint;\n    margin-bottom: 4px;\n  }\n\n  &__title {\n    @include ink.title(22px);\n    margin: 0;\n  }\n\n  &__tagline {\n    @include ink.lead;\n    margin-top: 6px;\n  }\n}\n\n.station-spawner-search {\n  flex: 0 0 auto;\n  padding: 0 24px 10px;\n\n  input {\n    @include ink.field;\n  }\n}\n\n.station-spawner-list {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  list-style: none;\n  margin: 0;\n  padding: 4px 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.station-spawner-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 10px;\n  font-family: ink.$font-text;\n  text-align: left;\n  color: ink.$text-2;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: ink.$radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n\n  &:hover {\n    color: ink.$text;\n    background: ink.$ink-raised;\n    border-color: ink.$line;\n  }\n\n  &:focus-visible {\n    color: ink.$text;\n    outline: 2px solid var(--gold-light);\n    outline-offset: -2px;\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  &__id {\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n}\n\n.station-spawner-empty {\n  padding: 8px 10px;\n  font-size: 14px;\n  color: ink.$text-3;\n}\n\n.station-spawner-footer {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 24px;\n  border-top: 1px solid ink.$line;\n\n  &__hint {\n    @include ink.hint;\n\n    kbd {\n      display: inline-block;\n      padding: 1px 6px;\n      margin-right: 6px;\n      font-family: ink.$font-text;\n      font-size: 12px;\n      color: ink.$text-2;\n      border: 1px solid ink.$line-strong;\n      border-radius: 4px;\n    }\n  }\n\n  &__status {\n    font-size: 13px;\n    text-align: right;\n    color: var(--gold-light);\n  }\n}\n\n.station-spawner-close {\n  @include ink.button;\n  @include ink.button-quiet;\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  padding: 2px 10px;\n  font-size: 20px;\n  line-height: 1.2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
